import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { BootcampdetailsPage } from 'src/app/pages/bootcampdetails/bootcampdetails.page';
import { BootcampfollowPage } from 'src/app/pages/bootcampfollow/bootcampfollow.page';
import { PopselectorPage } from 'src/app/pages/popselector/popselector.page';
import { BootcampService } from 'src/app/services/bootcamp/bootcamp.service';
import { CommunityService } from 'src/app/services/community/community.service';
import { NavigateService } from 'src/app/services/navigate/navigate.service';
import { chunkifyFixedSize, urlFix } from 'src/app/shared/routines';
import { Bootcamp, Community } from '../../shared/datamodel';
import { faAngleDoubleRight, faAngleDoubleLeft, faCreditCard, faClock,  faCalendar} from '@fortawesome/free-solid-svg-icons';
import { IonSlides, IonicModule } from '@ionic/angular';
import { NucampanalyticsService } from 'src/app/services/nucampanalytics/nucampanalytics.service';
import { UsersService } from 'src/app/services/users/users.service';
import { environment } from 'src/environments/environment';
import * as moment from 'dayjs';
import { NucampdatePipe } from '../../pipes/nucampdate/nucampdate.pipe';
import { EarlybirddatePipe } from '../../pipes/tuition/tuition.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ng2-tooltip-directive-ngfix';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, NgClass, CurrencyPipe } from '@angular/common';

/**
 * Generated class for the BootcampComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./bootcamp.scss'],
    selector: 'bootcamp',
    templateUrl: 'bootcamp.html',
    standalone: true,
    imports: [NgIf, IonicModule, RouterLink, NgFor, TooltipModule, NgClass, FontAwesomeModule, CurrencyPipe, EarlybirddatePipe, NucampdatePipe]
})
export class BootcampComponent implements OnChanges {
  @Input() bootcamp: Bootcamp;
  @Input() showSchedule: boolean;
  @Input() comingsoon: boolean;
  @Input() community: Community;
  @Input() view: string;
  @Input() completeBootcampOptions: any;
  @Output() cancelTimer: EventEmitter<any> = new EventEmitter();
  @Output() followCompleteBootcamp: EventEmitter<any> = new EventEmitter();
  diffShadowColor: any;

  @Output() scheduleTimer: EventEmitter<any> = new EventEmitter();
  @ViewChild('bootcampSlider') bootcampSlider: IonSlides
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleDoubleLeft = faAngleDoubleLeft;
  faCreditCard = faCreditCard;
  faClock = faClock;
  faCalendar = faCalendar;
  environment = environment;
  bdChunks;
  startEndBootcamps;

  bootcampDeliveriesOptions:any = {
    pagination: {el: '.swiper-pagination',type: 'bullets', clickable: true},
    navigation: {nextEl: '.nucamp-swiper-button-next',prevEl: '.nucamp-swiper-button-prev'},
    pager: true,
    grabCursor: true,
    breakpoints: {
      200: {slidesPerView: 1.2},
      720: {slidesPerView: 2},
      1100: {slidesPerView: 3},
    },
  }

  constructor ( 
    private bc: BootcampService,
    private nucampnav: NavigateService,
    private communitydb: CommunityService,
    private nucampAnalytics: NucampanalyticsService,
    private userdb: UsersService
  ) {
  }
  ngOnChanges(){
    // console.log("community", this.community);

    // console.log("this.bootcamp", this.bootcamp)
    if (this.completeBootcampOptions && this.completeBootcampOptions.bootcamps) {
      this.bootcampDeliveriesOptions.slidesPerView = this.completeBootcampOptions.bootcamps.length;
      this.bootcampDeliveriesOptions.slidesPerGroup = this.completeBootcampOptions.bootcamps.length;
      this.bootcampDeliveriesOptions.breakpoints[1100] = {slidesPerView: this.completeBootcampOptions.bootcamps.length};
    } else {
      this.bootcampDeliveriesOptions.slidesPerView = 3;
      this.bootcampDeliveriesOptions.slidesPerGroup = 1;
      // console.log("this.bootcampDeliveriesOptions", this.bootcampDeliveriesOptions, this.completeBootcampOptions)
    }
    if (this.bootcamp) {    
      // console.log("Bootcamp Display", this.bootcamp.deliveries);
      if (this.bootcamp.id === 'HT') {
        this.diffShadowColor = '#00618f'
      } else if (this.bootcamp.id === 'PY') {
        this.diffShadowColor = '#722462'
      } else {
        this.diffShadowColor = '#731439'
      }
    }
    if (this.bootcamp && this.bootcamp.bootcampdeliveries) {
      this.bootcamp.bootcampdeliveries.forEach((bd) => {
        bd.community.community.displayName = this.community?.displayName ? this.community.displayName : bd.community.community.city;
      }) 
    }
    if (this.bootcamp && this.bootcamp.bootcampdeliveries && this.completeBootcampOptions && this.completeBootcampOptions.bootcamps) {
      this.bdChunks = chunkifyFixedSize(this.bootcamp.bootcampdeliveries, this.completeBootcampOptions.bootcamps.length);
      console.log("this.bdChunks", this.bdChunks);
      this.setStartEndBootcamps(0);
    }
  }

  async followBootcamp(bootcamp) {
    this.cancelTimer.emit(null);
    await Promise.all([
      this.nucampAnalytics.browseWebsite(),
      this.bc.followBootcamp(BootcampfollowPage, bootcamp, this.userdb, false)
    ]);
  }

  async swipePrevBootcamps() {
    this.bootcampSlider.slidePrev();
    await Promise.all([
      this.setStartEndBootcamps(),
      this.nucampAnalytics.event("Page", "Slider", `Bootcamp Delivery | ${location}`),
      this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
    ]);
  }

  async setStartEndBootcamps(index?) {
    if (this.completeBootcampOptions && this.completeBootcampOptions.bootcamps && this.bdChunks) {
      let sIndex;
      if (index || index === 0) sIndex = index;
      else sIndex = Math.floor(await this.bootcampSlider.getActiveIndex() / this.completeBootcampOptions.bootcamps.length);
      // console.log("sIndex", sIndex);
      if (this.bdChunks[sIndex]) {
        this.startEndBootcamps = {
          dates:  moment(this.bdChunks[sIndex][0].startdate).format("MMMM YYYY") 
                  + " - " + 
                  moment(this.bdChunks[sIndex][this.bdChunks[sIndex].length - 1].enddate).format("MMMM YYYY"),
          startBootcampId: this.bdChunks[sIndex][0].id
        };
      }
    }
  }
  
  async ionSlideDidChange() {
    await Promise.all([
      this.setStartEndBootcamps(),
      this.nucampAnalytics.event("Page", "Slider", `Bootcamp Delivery | ${location}`),
      this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
    ]);
  }

  async swipeNextBootcamps() {
    await Promise.all([
      this.bootcampSlider.slideNext(),
      this.setStartEndBootcamps(),
      this.nucampAnalytics.event("Page", "Slider", `Bootcamp Delivery | ${location}`),
      this.nucampAnalytics.browseWebsite(this.userdb.loggedUser)
    ]);
  }

  getCommunityImage(community) {
    return this.communitydb.getCommunityPicture(community);
  }

  goToBootcampDetails(bootcampID){
    this.cancelTimer.emit(null);
    this.nucampnav.openModal(BootcampdetailsPage, {id: bootcampID}, {event: `Bootcamp Details ${bootcampID}`, cssClass: 'bootcampdetails-modal', showBackdrop: true, backdropDismiss: true})
    .then(modal => modal.present())
  }

  followCBootcamp() {
    this.followCompleteBootcamp.emit();
  }
  
  goToCompleteBootcampDetails(bootcampId) {
    return this.nucampnav.openPage(`/complete-bootcamp/${this.bootcamp.friendlyid}/${bootcampId}`);  
  }

  openCommunity(community) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    return this.nucampnav.openPage(`/community/${community.state.toLowerCase()}/${urlFix(community.name)}`);  
  }

  async requestCommunity() {
    this.nucampAnalytics.browseWebsite();
    this.cancelTimer.emit(null);
    // console.log("community", this.community);
    let postalcode = null;
    let geolocation = null;
    if (this.community && this.community.postalcode) postalcode = parseInt(this.community.postalcode);
    if (this.community && this.community.geolocation) geolocation = this.community.geolocation;
    let color = 'nucamp-advanced';
    if (this.bootcamp && this.bootcamp.name) color = `nucamp-${this.bootcamp.name.toLowerCase()}`;
    const alertDetails = {
      color: color,
      type: "browsecommunities", 
      header: "Select a Nucamp Community", 
      postalcode: postalcode,
      geolocation: geolocation
    }
    // const selectCommunity = await this.popoverCtrl.create({component: PopselectorPage, componentProps:{data: alertDetails}, cssClass: 'selector-popover', showBackdrop: true, backdropDismiss: true });
    const selectCommunity = await this.nucampnav.openModal(PopselectorPage, {data: alertDetails}, {cssClass: 'selector-popover-lg', showBackdrop: true, backdropDismiss: true });
    selectCommunity.onDidDismiss().then(async (event: any) => {
      if (event.data) {
        this.community = await this.communitydb.setCommunity(event.data.name, event.data.state);
      }
      // this.scheduleTimer.emit(null);
    })
    selectCommunity.present();
  }
 
  nStudentRegistered(students) {
    return students.filter(s => s.uid).length;
  }
}
